<template>
	<div class="d-flex gap-1" v-if="tipi.length > 0">
		<select v-if="tipi.length > 1" class="form-select form-select-sm w-auto" :value="tipoCorrente" :disabled="disabled" @change="cambiaTipo($event.target.value)">
			<option v-for="t in tipi" :key="t" :value="t">{{ t.charAt(0) + t.slice(1).toLowerCase() }}</option>
		</select>
		<div class="flex-fill">
			<Select2 :key="tipoCorrente" :modelValue="id" @update:modelValue="aggiorna" load-on-open :api="'shared-s2/commesse?TIPO=' + tipoCorrente" :apiselected="'shared-s2/commesse/selected?TIPO=' + tipoCorrente" :placeholder="placeholder" :disabled="disabled"></Select2>
		</div>
	</div>
</template>

<script>
import Select2 from '@/components/utils/Select2.vue'

// Select2 emette anche "_id" mentre risolve l'etichetta: qui conta solo il numero
const num = (v) => parseInt(String(v ?? '').replace(/_/g, '')) || 0;

// Tipi di commessa registrati dal progetto ospite (es. PROGETTO), letti una volta sola.
// Nessun tipo registrato = il pacchetto contabilità gira da solo e il campo non compare
let tipiCaricati = null;

export default {
	name: 'SelectCommessa',
	components: { Select2 },
	props: {
		tipo: { type: String, default: '' },
		id: { type: [Number, String], default: 0 },
		placeholder: { type: String, default: 'Nessuna commessa' },
		disabled: { type: Boolean, default: false }
	},
	emits: ['update:tipo', 'update:id', 'change'],
	data() {
		return { tipi: [] };
	},
	computed: {
		tipoCorrente() { return this.tipo || this.tipi[0] || ''; }
	},
	created() {
		if (!tipiCaricati) tipiCaricati = new Promise((resolve) => utils.ajax('shared-s2/commesse/tipi', {}, (response) => resolve(response.data || []), true, 0));
		tipiCaricati.then((tipi) => this.tipi = tipi);
	},
	methods: {
		cambiaTipo(tipo) {
			this.$emit('update:tipo', tipo);
			this.$emit('update:id', 0);
			this.$emit('change');
		},
		aggiorna(v) {
			const prima = num(this.id);
			this.$emit('update:id', v);
			this.$emit('update:tipo', num(v) > 0 ? this.tipoCorrente : '');
			if (num(v) != prima) this.$emit('change');
		}
	}
}
</script>
